import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';

import { InputAdornment, TextFieldProps } from '@mui/material';
import { TextField } from '@mui/material';

type Props = TextFieldProps & {
  control: Control<any>;
  name: string;
};

export default function ControlledPercentageField({
  control,
  name,
  label,
  variant = 'outlined',
  required
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          value={field.value}
          onChange={({ target: { value } }) => {
            field.onChange(value);
          }}
          label={label}
          type="number"
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>
          }}
          inputProps={{
            step: '0.01',
            style: { textAlign: 'right' }
          }}
          error={!!fieldState?.error?.type}
          helperText={fieldState?.error?.message}
          required={required}
          fullWidth
          size="small"
          variant={variant}
        />
      )}
    />
  );
}
